
import {
  AutocompleteChangeReason,
  AutocompleteInputChangeReason,
} from "@mui/material";
import React, { FC, SyntheticEvent } from "react";
import SearchField from "../../../components/SearchField/SearchField";
import { SearchResult, SearchSchoolDistrictContainerProps } from "../../../types/types";
import { useLazySearchSchoolDistrictByNameQuery } from "../api/schoolDistrictApiSlice";
import { SchoolDistrict } from "../types/types";

const SearchSchoolDistrictContainer: FC<
SearchSchoolDistrictContainerProps<SchoolDistrict>
> = ({ onChangeState, schoolDistrictID }) => {
  const [options, setOptions] = React.useState<SearchResult[]>([])

  const [searchSchoolDistrictByName, { isLoading}] =
    useLazySearchSchoolDistrictByNameQuery();

  const onFetch = async (
    event: SyntheticEvent<Element, Event>,
    value: string,
    reason: AutocompleteInputChangeReason
  ) => {
    try {
      const newOptions = await searchSchoolDistrictByName(value).unwrap()

      setOptions(newOptions);
    } catch (error) {console.error(error)}
  };

  const onChagneHandler = (
    event: SyntheticEvent<Element, Event>,
    value: SearchResult | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value?.id) {
      onChangeState({ _id: value.id, agancy_name: value.label })
    }
  }

  return (
    <SearchField
      options={options}
      loading={isLoading}
      handleInputChange={onFetch}
      onChangeHandle={onChagneHandler}
      schoolDistrictID={schoolDistrictID}
    />
  )
}

export default SearchSchoolDistrictContainer
